import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import _, { get } from 'lodash';
import { formFields } from './constant';
import { handleFieldError } from '../../../utils/form-validation';
import SelectNew from '../../FormElements/SelectNew';
import { withRouter } from 'react-router-dom';
import { thirdPartyAccountAction } from '../../../actions/thirdPartyAccount';
import MultiSelectWithCheckboxes from '../../MultiSelectWithCheckboxes';

const MetaAccount = ({ accounts, platform, isDisplayAccountName = false, children, resignInSeatData }) => {
    const [form, setForm] = useState({});
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [options, setOptions] = useState({
        accountOptions: []
    });

    const [accountName, setAccountName] = useState('');
    const [accountCurrency, setAccountCurrency] = useState('');
    const [pageList, setPageList] = useState([]);
    const [selectedPages, setSelectedPages] = useState([]);

    const thirdPartyAccount = useSelector(state => get(state, 'app.thirdPartyAccount', {}));
    const tenantId = useSelector((state) => get(state, "app.preSignInState.tenantId", ""));

    const dispatch = useDispatch();

    const handleChange = (e) => {
        try {
            const { name, value } = e.target;
            const newForm = { ...form };
            newForm[e.target.name] = value;
            setForm(newForm);
            if (name == formFields.accountId.key) {
                let adAccounts = accounts[0].adAccounts;
                let selectedAccount = adAccounts.find(account => account.id == value);
                let pages = accounts[0].pages;
                if (thirdPartyAccount && thirdPartyAccount.account && thirdPartyAccount.account.hasOwnProperty('pages')) {
                    pages = thirdPartyAccount.account['pages'];
                }
                if (selectedAccount) {
                    setAccountName(selectedAccount.name);
                    setAccountCurrency(selectedAccount.currency);
                    let data = {
                        currency: selectedAccount.currency,
                        token: accounts[0].accessToken,
                        emailId: selectedAccount.email ? adAccounts[0].email : '',
                        accountId: selectedAccount.id,
                        accountName: selectedAccount.name,
                        timeZone: selectedAccount.timeZone,
                        pages
                    };
                    dispatch(
                        thirdPartyAccountAction({
                            thirdPartyAccount: {
                                account: data
                            }
                        })
                    );
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleTouch = (e) => {
        try {
            const newTouched = { ...touched };
            const newErrors = { ...errors };
            const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
            newErrors[e.target.name] = error;
            newTouched[e.target.name] = true;
            setTouched(newTouched);
            setErrors(newErrors);
        } catch (error) {
            console.log(error);
        }
    };

    const initialize = () => {
        try {
            if (accounts && accounts.length > 0) {
                let adAccounts = accounts[0].adAccounts;
                if (resignInSeatData) {
                    adAccounts = adAccounts.filter(account => account.id == resignInSeatData.accountId);
                }
                let pagesData = [];
                if (accounts[0].pages) {
                    pagesData = accounts[0].pages;
                    pagesData = pagesData.map(page => ({ ...page, value: page.id, label: page.name, fbPageToken: page['access_token'] }));
                    setPageList(pagesData);
                }
                if (adAccounts && adAccounts.length == 1) {
                    let accountOptions = adAccounts.map(account => ({ key: account.id, value: `${account.id}` }));
                    setOptions({
                        accountOptions: accountOptions
                    });
                    setForm({ ...form, accountId: adAccounts[0].id });
                    setAccountName(adAccounts[0].name);
                    setAccountCurrency(adAccounts[0].currency);
                    let data = {
                        currency: adAccounts[0].currency,
                        token: accounts[0].accessToken,
                        emailId: adAccounts[0].email ? adAccounts[0].email : '',
                        accountId: adAccounts[0].id,
                        accountName: adAccounts[0].name,
                        timeZone: adAccounts[0].timeZone,
                        pages: pagesData
                    };
                    dispatch(
                        thirdPartyAccountAction({
                            thirdPartyAccount: {
                                account: data
                            }
                        })
                    );
                } else if (adAccounts.length > 1) {
                    const accountOptions = adAccounts.map(account => ({ key: account.id, value: `${account.id}` }));
                    setOptions({
                        accountOptions: accountOptions
                    });
                } else {

                }
            } else {
                throw new Error('else case handle!');
            }
        } catch (e) {
            console.log(e);
        }
    }

    const handleSelectedPages = (selectedValues, nonSelectedValues) => {
        try {
            let selectedPageIds = selectedValues.map(page => page.id);
            // let nonSelectedPageIds = nonSelectedValues.map(page => page['value']);
            let pages = pageList.map(page => {
                if (selectedPageIds.includes(page['id'])) {
                    page['isRecActive'] = 1;
                }
                if (!selectedPageIds.includes(page['id'])) {
                    page['isRecActive'] = 0;
                }
                return {
                    ...page,
                    pageId: page.id,
                    pageName: page.name
                }
            });
            dispatch(
                thirdPartyAccountAction({
                    thirdPartyAccount: {
                        account: {
                            ...thirdPartyAccount.account,
                            pages
                        }
                    }
                })
            );
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        initialize();
    }, []);

    useEffect(() => {
        try {
            if (resignInSeatData && Object.keys(resignInSeatData).length > 0 && resignInSeatData.hasOwnProperty('pages') && pageList.length > 0) {
                let pages = (resignInSeatData['pages'] && resignInSeatData['pages'].length > 0) ? resignInSeatData['pages'] : [];
                pages = pages.map(page => ({ ...page, value: page.pageId, label: page.pageName }));
                let pageListIds = pageList.map(page => page['id']);
                pages = pages.filter(page => pageListIds.includes(page['pageId']) && page['advertiserId'] == tenantId);
                setSelectedPages(pages);
                let data = { pages };
                if (Array.isArray(data['pages']) && data['pages'].length > 0) {
                    dispatch(
                        thirdPartyAccountAction({
                            thirdPartyAccount: {
                                account: data
                            }
                        })
                    );
                }
            }
        } catch (error) {
            console.log(error);
        }
    }, [pageList]);

    return (
        <div className="row m-0">
            <div className="col-md-3">
                <div style={{ color: '#1B2559', fontSize: 14 }} className="text-primary text-center">
                    <SelectNew
                        onChange={handleChange}
                        onBlur={handleTouch}
                        value={form[formFields.accountId.key]}
                        setting={formFields[formFields.accountId.key]}
                        error={errors[formFields.accountId.key]}
                        submited={false}
                        touched={touched[formFields.accountId.key]}
                        options={options.accountOptions}
                        disabled={(accounts[0].adAccounts && accounts[0].adAccounts.length == 1) ? true : false}
                    />
                </div>
            </div>
            <div className="col-md-3 d-flex flex-column justify-content-center align-items-center">
                <div className="form-group row">
                    <label class="col-sm-12 col-form-label">Account Name</label>
                    <div style={{ color: '#1B2559', fontSize: 14 }} className="text-primary my-2">{accountName}</div>
                </div>
            </div>
            {
                isDisplayAccountName ?
                    <div className="col-md-3">
                        {children}
                    </div>
                    :
                    null
            }
            <div className="col-md-3 d-flex flex-column justify-content-center align-items-center">
                <div className="form-group row">
                    <label class="col-sm-12 col-form-label">Account Currency</label>
                    <div style={{ color: '#1B2559', fontSize: 14 }} className="text-primary my-2">{accountCurrency}</div>
                </div>
            </div>

            <div className="col-md-3">
                <div className="form-group row">
                    <label class="col-sm-8 col-form-label">Meta Page List</label>
                    <div className="col-md-12">
                        <MultiSelectWithCheckboxes
                            options={pageList}
                            onSelectionChange={(selectedValues, nonSelectedValues) => {
                                handleSelectedPages(selectedValues, nonSelectedValues);
                            }}
                            placeholder={'Select Pages'}
                            selectAll={true}
                            disabledView={false}
                            styles={{
                                width: '100%'
                            }}
                            selectedValues={selectedPages}
                        />
                        {/* <MultiSelectWithAllOption
                            options={pageList}
                            handleSelectedValues={handleSelectedPages}
                            placeholder={'Select Pages'}
                        /> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withRouter(MetaAccount);